/**
 * Simple ID obfuscation for URLs.
 * NOT cryptographic security — just prevents casual ID guessing.
 * Real security must be enforced server-side.
 */

const SALT = 'bmv2026'
const OFFSET = 48731

/**
 * Encode a numeric ID into an obfuscated string
 * @param {number|string} id
 * @returns {string}
 */
export function hashId(id) {
    const num = parseInt(id, 10)
    if (isNaN(num)) return id
    const shifted = num + OFFSET
    const encoded = btoa(SALT + ':' + shifted)
    // Make URL-safe: replace +/= with -_~
    return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

/**
 * Decode an obfuscated string back to the original numeric ID
 * @param {string} hash
 * @returns {number|null}
 */
export function unhashId(hash) {
    if (!hash) return null
    // Try plain numeric first (backwards compat)
    const plain = parseInt(hash, 10)
    if (!isNaN(plain) && String(plain) === String(hash)) return plain
    try {
        // Restore base64 padding
        const base64 = hash.replace(/-/g, '+').replace(/_/g, '/')
        const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
        const decoded = atob(padded)
        const parts = decoded.split(':')
        if (parts[0] !== SALT) return null
        const shifted = parseInt(parts[1], 10)
        if (isNaN(shifted)) return null
        return shifted - OFFSET
    } catch (e) {
        return null
    }
}
